// extracted by mini-css-extract-plugin
export default {"icon":"IsKeyDate_icon__zXac2"};